import { toast } from "sonner";

export type NotifyOptions = {
  description?: string;
  action?: { label: string; onClick: () => void };
  duration?: number;
};

export const notify = {
  success: (title: string, opts: NotifyOptions = {}) =>
    toast.success(title, opts),
  info: (title: string, opts: NotifyOptions = {}) => toast.message(title, opts),
  warn: (title: string, opts: NotifyOptions = {}) => toast.warning(title, opts),
  error: (title: string, opts: NotifyOptions = {}) => toast.error(title, opts),
  promise: <T>(
    p: Promise<T>,
    msgs: { loading: string; success: string; error: string },
  ) => toast.promise(p, msgs),
};

export default notify;
